export default {
    namespaced: true,
    state: {
        report_initial_values: {}
    },
    getters: {
        getReportInitialValues: state => state.report_initial_values
    },
    mutations: {
        setReportInitialValues (state, report_initial_values) {
            state.report_initial_values = report_initial_values;
        }
    }
}